import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { IBusinessParam } from "@/pages/profile/hooks/useBusinessParam";
import { PhoneAppealState } from "project-config/constants/user-info";
import { getUserKey } from "@/utils/getUesrKey";

export interface IUseProfileInfo {
  accountType: number;
  companyAppealResp?: { state: PhoneAppealState; take: number };
  email: string;
  expand: string;
  loggedPlatform: string;
  phone: string;
  productLine: {
    name: null;
    type: null;
    redirectUrl: null;
    logoAddr: null;
    themeColor: null;
    auxiliaryColor: null;
  };
  registerPlatform: null;
  serialNum: number;
  thirdPartyResps: null;
  unionId: string;
  userName: string;
}

export function useProfileInfo(businessParam?: IBusinessParam) {
  const [profileInfo, setProfileInfo] = useState<IUseProfileInfo>();

  const { data } = useQuery<IUseProfileInfo>(
    [
      "/api/sso/userInfo/getInfo",
      {},
      {
        method: "get",
        // 携带产品线信息
        headers: {
          ...businessParam,
          rsAuthToken: getUserKey(),
        },
      },
    ],
    { enabled: !!businessParam }
  );

  useEffect(() => {
    if (!data) return;
    setProfileInfo(data);
  }, [data]);

  return { profileInfo };
}
